'use client';

import dynamic from 'next/dynamic';

/**
 * Dev-only breakpoint badge. Dynamic-imports `Breakpoints` so production
 * DocumentShell never pulls the module into its static import graph.
 */
const BreakpointsDynamic =
  process.env.NODE_ENV === 'development'
    ? dynamic(
        () =>
          import('@/components/dev/Breakpoints').then((mod) => mod.Breakpoints),
        { ssr: false },
      )
    : null;

export function DevBreakpointsGate() {
  if (!BreakpointsDynamic) return null;
  return <BreakpointsDynamic />;
}
